import * as stringConstants from '../constants/stringConstants';

export const getPaginationIndexes = (data, currentPage, itemsPerPage) => {
  const multiIndex = [];
  const beginIndex = (currentPage - 1) * itemsPerPage;
  let endIndex = beginIndex + itemsPerPage;
  endIndex = endIndex < data.length ? beginIndex + itemsPerPage : data.length;
  multiIndex.push(beginIndex, endIndex);

  return multiIndex;
};

export const isTaxFieldVisible = (taxField, country) => {
  switch (taxField) {
    case stringConstants.ABN:
      return country.toLowerCase() === 'australia';
    case stringConstants.BUSINESS_REG_CERT_NO:
      return country.toLowerCase() === 'hong kong';
    case stringConstants.IS_MSME:
      return country.toLowerCase() === 'india';
    case stringConstants.PAN:
      return country.toLowerCase() === 'india';
    case stringConstants.SERVICE_TAX:
      return country.toLowerCase() === 'india';
    case stringConstants.REGISTERED_STATE:
      return country.toLowerCase() === 'japan';
    case stringConstants.REGISTRATION_NUMBER:
      return country.toLowerCase() === 'japan';
    case stringConstants.TIN:
      return country.toLowerCase() === 'philippines' || country.toLowerCase() === 'united states';
    case stringConstants.UEN:
      return country.toLowerCase() === 'singapore';
    case stringConstants.NIF:
      return country.toLowerCase() === 'spain';
    default:
      return true;
  }
}

export const isBillingCountryAndCountryFrance = (billingCountry, country) => {
  return billingCountry.toLowerCase() === 'france' && country.toLowerCase() === 'france';
};

export const isPaymentMethodCPCOrBIP = (paymentMethod) => {
  paymentMethod = paymentMethod.toLowerCase();
  return paymentMethod === stringConstants.CPC || paymentMethod === stringConstants.BIP;
};

export const isPaymentMethodElectronic = (paymentMethod) => {
  return paymentMethod?.toLowerCase() === stringConstants.ELECTRONIC;
};

export const isBillingCountryUSA = (countryName) => {
  return countryName.toLowerCase() === stringConstants.USA;
}